const GSM_BASIC = new Set(
  '@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&\'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà'
);
const GSM_EXTENSION = new Set('^{}\\[~]|€');
const EMOJI_PATTERN = /\p{Extended_Pictographic}|[\u{1F1E6}-\u{1F1FF}]|\uFE0F|\u20E3/u;

export const analyzeSmsEncoding = (message = '') => {
  let gsmUnits = 0;
  let hasUnicode = false;

  for (const character of message) {
    if (GSM_BASIC.has(character)) gsmUnits += 1;
    else if (GSM_EXTENSION.has(character)) gsmUnits += 2;
    else hasUnicode = true;
  }

  const encoding = hasUnicode ? 'UCS-2' : 'GSM-7';
  const units = hasUnicode ? message.length : gsmUnits;
  const singleLimit = hasUnicode ? 70 : 160;
  const joinedLimit = hasUnicode ? 67 : 153;

  return {
    encoding,
    segments: units === 0 ? 0 : units <= singleLimit ? 1 : Math.ceil(units / joinedLimit),
    hasEmoji: EMOJI_PATTERN.test(message),
  };
};
